import { isString } from "@payair/e-com-common-sdk/core/Validators";
/** @internal */
export var validateApplePayShippingMethod = function (applePayShippingMethod) {
    var errorMessage = [];
    if (!applePayShippingMethod.label)
        errorMessage.push("applePayShippingMethod.label is not defined");
    else if (!isString(applePayShippingMethod.label))
        errorMessage.push("applePayShippingMethod.label is not a string");
    if (!applePayShippingMethod.detail)
        errorMessage.push("applePayShippingMethod.detail is not defined");
    else if (!isString(applePayShippingMethod.detail))
        errorMessage.push("applePayShippingMethod.detail is not a string");
    if (!applePayShippingMethod.amount)
        errorMessage.push("applePayShippingMethod.amount is not defined");
    else if (!isString(applePayShippingMethod.amount))
        errorMessage.push("applePayShippingMethod.amount is not a string");
    if (!applePayShippingMethod.identifier)
        errorMessage.push("applePayShippingMethod.identifier is not defined");
    else if (!isString(applePayShippingMethod.identifier))
        errorMessage.push("applePayShippingMethod.identifier is not a string");
    return errorMessage;
};
